/**
 * CopyIcon/index.js
 * desc: content copy icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CopyIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="copy icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.copy.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 19 22" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h12v2H2v14H0V2C0 .9.9 0 2 0zm4 4h11c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/></svg>
    </IconButton>
);


export default CopyIcon;
